import { bus } from "@/bus";
import { setupNovologikConnector } from "@/composables/connectors/novologik";

// Vue 3 migration: app.use(ConnectorsPlugin, { store })
export default {
	install(Vue, { store }) {
		setupNovologikConnector(store, bus);
		// Future connectors: setupXyzConnector(store, bus);
	}
};
